import { CareRecipientHouseId } from "../care_recipient/CareRecipientHouseId";
import { DateTime } from "../fundamental/DateTime";
import { UserAccountRole } from "../user/account/UserAccountRole";
import { UserEmail } from "../user/UserEmail";
import { UserId } from "../user/UserId";
import { UserName } from "../user/UserName";

const LoginLogType = Symbol();

export class LoginLog {
    [LoginLogType]: any;
    readonly userId: UserId;
    readonly userName: UserName;
    readonly email: UserEmail;
    readonly role: UserAccountRole;
    readonly time: DateTime;
    readonly houseIdList: CareRecipientHouseId[];

    private constructor(
        userId: UserId,
        userName: UserName,
        email: UserEmail,
        role: UserAccountRole,
        time: DateTime,
        houseIdList: CareRecipientHouseId[]
        
    ) {
        this.userId = userId;
        this.userName = userName;
        this.email = email;
        this.role = role;
        this.time = time;
        this.houseIdList = houseIdList;
    }

    static from(
        userId: UserId,
        userName: UserName,
        email: UserEmail,
        role: UserAccountRole,
        time: DateTime,
        houseIdList: CareRecipientHouseId[]
    ): LoginLog {
        return new LoginLog(userId, userName, email, role, time, houseIdList);
    }
}

export type LoginLogJson = {
    userId: string,
    userName: string,
    email: string,
    role: string,
    time: string,
    houseIdList: string[]
}
